import { render } from "./PositionsView.vue?vue&type=template&id=aebb418a"
import script from "./PositionsView.vue?vue&type=script&lang=js"
export * from "./PositionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__